module.exports = __webpack_public_path__ + "static/media/icon-lp-direct-messaging.6bf7cf50.svg";